// extracted by mini-css-extract-plugin
export default {"pageLayoutContainer":"PageLayout_pageLayoutContainer__FHW0O","childContainer":"PageLayout_childContainer__xbc28"};